// Globals
import { useTranslation } from 'react-i18next';

// Store
import { useAppDispatch, useAppState } from '@/store';
import { changeOrderStatus, completeOrder, selectOrder, selectOrdersIsLoading } from '../../feature';

// Components
import { StyledTabs } from '../../components';
import { StyledContainer } from './SettlementDetailsContainerStyles';
import SettlementDetails from '../../components/SettlementDetails/SettlementDetails';

// Modules
import { LogsListContainer } from '@/modules/Logs';

// Models
import { EntityType } from '@/models/logs.model';
import { OrderStatus } from '@/models/order.model';

// Helpers
import { getEntityId } from '@/utils';

const SettlementDetailsContainer = () => {
  const { t } = useTranslation('order');
  const dispatch = useAppDispatch();
  const isLoading = useAppState(selectOrdersIsLoading);

  const order = useAppState(selectOrder);
  const canComplete = order?.status === OrderStatus.IN_PROGRESS;

  const handleChangeStatus = (status: OrderStatus) =>
    dispatch(changeOrderStatus({ id: getEntityId(order?.PK ?? ''), status }));

  const handleCompleteOrder = () => dispatch(completeOrder({ id: getEntityId(order?.PK ?? '') }));

  if (!order) return null;

  return (
    <StyledTabs
      destroyInactiveTabPane
      items={[
        {
          key: 'details',
          label: t('details'),
          children: (
            <StyledContainer>
              <SettlementDetails
                order={order}
                canComplete={canComplete}
                onStatusChange={handleChangeStatus}
                isLoading={isLoading}
                handleCompleteOrder={handleCompleteOrder}
              />
            </StyledContainer>
          ),
        },
        {
          key: 'logs',
          label: t('logs'),
          children: <LogsListContainer id={order?.PK ?? ''} entityType={EntityType.ORDER} />,
        },
      ]}
    />
  );
};

export default SettlementDetailsContainer;
